import { Box, Grid, Typography } from '@mui/material';
import { keypadStyles } from './styles';
import { NumericKeypadProps, KeypadKey } from './types';

const KEYPAD_KEYS: KeypadKey[] = [
  { num: 1, letters: '' },
  { num: 2, letters: 'ABC' },
  { num: 3, letters: 'DEF' },
  { num: 4, letters: 'GHI' },
  { num: 5, letters: 'JKL' },
  { num: 6, letters: 'MNO' },
  { num: 7, letters: 'PQRS' },
  { num: 8, letters: 'TUV' },
  { num: 9, letters: 'WXYZ' },
  { num: '*', letters: '' },
  { num: 0, letters: '+' },
  { num: '#', letters: '' },
];

export const NumericKeypad = ({ onKeyPress }: NumericKeypadProps) => (
  <Grid sx={keypadStyles.container} container spacing={1}>
    {KEYPAD_KEYS.map((key) => (
      <Grid item xs={4} sx={keypadStyles.gridItem} key={key.num}>
        <Box onClick={() => onKeyPress(key.num.toString())} sx={keypadStyles.keyButton}>
          <Typography variant="h6">{key.num}</Typography>
          <Typography variant="caption" sx={{ lineHeight: 1 }}>
            {key.letters}
          </Typography>
        </Box>
      </Grid>
    ))}
  </Grid>
);
